// Light theme (white background) - used across tools and calculators
export const toolCardClass = 'border-slate-200 bg-white shadow-sm hover:shadow-md hover:border-slate-300/80 transition-all duration-200';
export const toolInputClass = 'bg-white border-slate-200 text-slate-900 placeholder:text-slate-400 focus-visible:ring-brand-900/20 focus-visible:border-brand-900';
export const toolLabelClass = 'text-slate-600';
export const toolButtonOutlineClass = 'border-slate-300 bg-white text-slate-700 hover:bg-brand-50 hover:border-brand-900/30';
